import { useEffect } from "react";
import { useDispatch } from "react-redux";

export function useFetchOutlookIdOnLoad() {
  const dispatch = useDispatch();

  useEffect(() => {
    fetchAndStoreOutlookId(dispatch);
  }, [dispatch]);
}

/**
 * Outlook-ID des Termins holen und ablegen.
 *
 * Liefert `{ id }` oder `{ error }`. Der Fehlerfall ging früher nur in die
 * Konsole — der Anwender sah dann eine Schaltfläche, die ewig "Wird gesendet…"
 * anzeigte, ohne dass je ein Aufruf losging. Ohne gespeicherten Outlook-Termin
 * gibt es keine ID und damit keine Einladung, das gehört gesagt.
 */
export function fetchAndStoreOutlookId(dispatch) {
  return new Promise((resolve) => {
    getEventOutlookUid((err, eventOutlookUid) => {
      if (eventOutlookUid) {
        dispatch(setAppointmentData(eventOutlookUid));
        resolve({ id: eventOutlookUid });
        return;
      }
      if (err) {
        console.error("Outlook-ID nicht lesbar:", err);
        resolve({ error: err.message });
        return;
      }
      // Neuer Termin: Outlook vergibt die ID erst beim Speichern.
      try {
        Office.context.mailbox.item.saveAsync(function (result) {
          if (result.status === Office.AsyncResultStatus.Succeeded) {
            dispatch(setAppointmentData(result.value));
            resolve({ id: result.value });
          } else {
            console.error("saveAsync fehlgeschlagen:", result.error);
            resolve({ error: result.error?.message || "Outlook hat den Termin nicht gespeichert" });
          }
        });
      } catch (e) {
        console.error("saveAsync nicht ausführbar:", e);
        resolve({ error: e.message });
      }
    });
  });
}

function setAppointmentData(outlookId) {
  return {
    type: "SET_APPOINTMENT_DATA",
    payload: {
      outlook_id: outlookId,
    },
  };
}

function getEventOutlookUid(callback) {
  if (typeof Office.context.mailbox.item.getItemIdAsync === "function") {
    Office.context.mailbox.item.getItemIdAsync(function (result) {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        callback(null, result.value);
      } else {
        console.warn(`EventOutlookUid unavailable: ${result.error.message}. Probably just a new event`);
        callback(null, null);
      }
    });
  } else if (Office.context.mailbox.item.itemId) {
    callback(null, Office.context.mailbox.item.itemId);
  } else {
    callback(
      new Error(
        "Neither Office.context.mailbox.item.getItemIdAsync nor Office.context.mailbox.item.itemId could get Outlook Item UID",
      ),
      null,
    );
  }
}
